var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    fill: "#F1F0F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_276_61820",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 136,
    height: 136
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    fill: "#EFF4FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_276_61820)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_276_61820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.319 51.7134C113.596 51.7134 107.763 49.387 105.818 48.6115C95.3172 43.9586 77.8158 30 68.4817 30C59.1476 30 41.6462 43.9586 31.1454 48.6115C29.2008 49.387 23.367 51.7134 20.6445 51.7134C16.7553 51.7134 13.644 55.2031 14.0329 59.4682C15.1997 68.774 17.5332 85.4468 24.1448 106.773C32.3121 133.139 56.0362 149.036 64.9814 154.077C67.3149 155.24 70.0374 155.24 71.982 154.077C80.9271 149.036 104.651 133.139 112.819 106.773C119.43 85.4468 122.153 68.774 122.93 59.4682C123.319 55.2031 120.208 51.7134 116.319 51.7134Z",
    fill: "url(#paint0_linear_276_61820)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.208 60.6312C112.43 67.9982 110.486 79.6305 106.207 94.3646C105.819 95.14 105.819 95.9155 105.43 97.0788C105.041 99.0175 104.263 101.344 103.485 103.283C99.5958 116.078 91.4285 126.159 83.2612 133.526C77.8163 138.567 71.9825 142.444 68.4822 144.771C67.7044 144.383 66.5376 143.608 65.3708 142.832C55.6478 136.24 39.3132 123.057 33.4794 103.67C27.6456 84.6711 24.9232 69.5492 24.1453 61.0189C28.8124 60.2435 34.2573 57.917 35.424 57.5293C39.7021 55.5906 44.3692 52.4887 49.4251 49.3867C54.87 45.8971 65.3708 39.6932 68.8711 39.6932C72.3714 39.6932 82.8722 46.2848 88.3171 49.3867C93.3731 52.4887 98.0401 55.5906 102.318 57.5293C103.096 57.5293 108.541 59.8557 113.208 60.6312Z",
    fill: "url(#paint1_linear_276_61820)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.208 94.3647C105.819 95.1401 105.819 95.9156 105.43 97.0788C105.042 99.0175 104.264 101.344 103.486 103.283C99.5966 116.078 91.4293 126.159 83.262 133.526L55.2598 105.609L57.2044 90.875L73.539 82.7325L63.4271 83.5079L60.7047 66.4474L75.0947 63.3455L106.208 94.3647Z",
    fill: "url(#paint2_linear_276_61820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8172 78.8555V69.9375C77.8172 65.6723 74.3169 61.4072 70.4277 60.6317C67.3163 60.244 64.205 61.0195 62.2604 63.3459C60.7047 64.8969 59.5379 67.2233 59.5379 69.9375V79.2432C57.2044 80.7942 54.8709 83.1206 53.3152 85.4471C51.7595 87.7735 50.9817 90.4877 50.9817 93.5896C50.5928 103.283 58.3712 111.426 68.0942 111.813C78.2061 112.201 86.3734 104.059 86.3734 94.3651C86.3734 87.7735 82.8731 81.9574 77.8172 78.8555ZM70.8166 95.9161V100.569C70.8166 101.344 70.4277 101.732 69.6499 101.732H67.7053C66.9274 101.732 66.5385 101.344 66.5385 100.569V97.467V95.5283C64.5939 95.1406 63.8161 93.2019 64.205 91.2632C64.5939 89.7122 65.7607 88.1612 67.7053 87.7735C70.4277 86.998 73.1501 89.3245 73.1501 92.0387C72.7612 93.5896 71.9834 95.1406 70.8166 95.9161ZM73.928 77.3045C72.3723 76.9168 70.4277 76.5291 68.4831 76.5291C66.9274 76.5291 64.9828 76.9168 63.4271 77.3045V70.3252C63.4271 68.7742 64.205 67.611 64.9828 66.8356C66.1496 65.6723 68.4831 64.8969 70.8166 65.6723C72.7612 66.4478 73.928 68.3865 73.928 70.713V77.3045Z",
    fill: "url(#paint3_linear_276_61820)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_276_61820",
    x: 6,
    y: 27,
    width: 124.963,
    height: 140.949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_276_61820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_276_61820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_276_61820",
    x1: 62.2244,
    y1: 68.3859,
    x2: 97.5112,
    y2: 118.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737098"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_276_61820",
    x1: 100.766,
    y1: 120.323,
    x2: 47.5989,
    y2: 52.4124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1AED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_276_61820",
    x1: 76.6021,
    y1: 95.8385,
    x2: 96.1282,
    y2: 115.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737098",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_276_61820",
    x1: 85.9973,
    y1: 105.166,
    x2: 53.0938,
    y2: 72.1632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.6a624a4b37b2deed721bfbf7e7d29940.svg";
export { ForwardRef as ReactComponent };